import { Component, OnInit ,ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TicketsService } from 'src/app/_services/tickets.service';
import { User } from 'src/app/_models';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-over-due-tickets',
  templateUrl: './over-due-tickets.component.html',
  styleUrls: ['./over-due-tickets.component.css'],
})
export class OverDueTicketsComponent implements OnInit {
  displayedColumns: string[] = [
    'no',
    'name',
    'assignedTo',
    'startDate',
    'status',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  loading = true;
  error = '';
  dataSource;
  arr;
  title = 'materialApp'; 
  color = 'primary';
  mode = 'indeterminate';
  value = 75;
  diameter=60
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public userId: string;
  public total: number;
  constructor(private ticketservice: TicketsService) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.userId = this.currentUserSubject.value.userId;
  }

  ngOnInit(): void {
    this.GetOverDueTickets();
    this.dataSource.paginator = this.paginator;    

  }

  GetOverDueTickets() {
    this.ticketservice.getOverDueTickets(this.userId).subscribe(
      (res) => {
        // console.log(res);
        // this.dataSource = <any>res;
        // this.total = this.dataSource.length;
        this.arr = res  
        this.dataSource = new MatTableDataSource(this.arr);  
        this.dataSource.paginator = this.paginator;    
        this.total = this.arr.length; 
        this.loading = false

      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }
}
